export const DEFAULT_LOGO = "defaultLogo.svg";

// Decide qual valor de imgLogo persistir ao salvar a empresa.
// - Se um novo logo acabou de ser enviado, usa-o (fonte da verdade).
// - Senão preserva o logo atual, ignorando o placeholder padrão
//   ("defaultLogo.svg") para não gravar uma imagem inexistente.
export const resolveLogoForSave = (uploadedLogo, currentImgLogo) => {
  if (Array.isArray(uploadedLogo) && uploadedLogo.length > 0) {
    return uploadedLogo;
  }
  if (currentImgLogo && currentImgLogo !== DEFAULT_LOGO) {
    return [currentImgLogo];
  }
  return [];
};
